/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import Slider from 'react-slick';
import {
    array, func, object, bool, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CustomCarouselStyles from './CustomCarouselStyles';
import ProductItem from './ProductItem';

const NextArrow = (props) => {
    const { onClick, className } = props;
    return (
        <button type="button" aria-label="Next Arrow" className={`${className}`} onClick={onClick}>
            <ChevronRightIcon className="material-icons text-icon" />
        </button>
    );
};
NextArrow.propTypes = {
    onClick: func,
    className: string,
};

NextArrow.defaultProps = {
    onClick: () => {},
    className: '',
};

const PrevArrow = (props) => {
    const { onClick, className } = props;
    return (
        <button type="button" aria-label="Prev Arrow" className={`${className}`} onClick={onClick}>
            <ChevronLeftIcon className="material-icons text-icon" />
        </button>
    );
};

PrevArrow.propTypes = {
    onClick: func,
    className: string,
};
PrevArrow.defaultProps = {
    onClick: () => {},
    className: '',
};

const CustomCarousel = (props) => {
    const {
        data = [], classes, carousel_settings, isTopTrendingProduct, presentationFamily, brand,
    } = props;
    const settings = { ...carousel_settings, nextArrow: <NextArrow />, prevArrow: <PrevArrow /> };

    const ProductItemWrapper = (item, index) => {
        const itemData = {
            isTopTrendingProduct,
            productCategory: 'slider',
            item,
            key: item.id,
            index,
        };

        return <ProductItem key={item.id} item={itemData} presentationFamily={presentationFamily} brand={brand} />;
    };

    if (!data.length) return null;
    return (
        <Slider {...settings} className={`slider-container ${classes.slider_container}`}> {/* eslint-disable-line */}
            { data.map((item, index) => ProductItemWrapper(item, index)) }
        </Slider>
    );
};

CustomCarousel.propTypes = {
    data: array.isRequired,
    carousel_settings: object.isRequired,
    classes: object.isRequired,
    isTopTrendingProduct: bool,
    presentationFamily: string,
    brand: object,
};

CustomCarousel.defaultProps = {
    brand: {},
    presentationFamily: '',
    isTopTrendingProduct: false,
};

export default withStyles(CustomCarouselStyles)(CustomCarousel);
